﻿import { rootElement } from '@shared/setup';
import AccountInvoices from '@cwd/Account/AccountInvoices/AccountInvoices.vue';

const initAccountInvoices = async () => {
    rootElement({
        name: 'account-invoices', // pascal, camel & kebab-case are valid
        component: AccountInvoices,
        vm: {},
        contextComponents: ['<div>waiting</div>'],
    });
};
initAccountInvoices();
